
import React, { useEffect } from 'react';
import { makeStyles } from '@material-ui/styles';


const useStyles = makeStyles(() => ({
    root: {
        width: '100%',
        borderRadius: 8,
        border: '1px solid rgb(107,114,128)',
        padding: 12,
        marginBottom: 5,
        display: 'flex',
        alignItems: 'center',
        cursor: 'pointer',
        transitionProperty: "all",
        transitionTimingFunction: "cubic-bezier(0.4, 0, 0.2, 1)",
        transitionDuration: "150ms",
    },
    gridQuestionTrue: {
        minWidth: 13,
        minHeight: 13,
        border: '2px solid white',
        borderRadius: '50%',
        margin: '1px 0px'
    },
    gridQuestionFalse: {
        minWidth: 14,
        minHeight: 14,
        border: '1px solid rgb(107,114,128)',
        borderRadius: '50%',
        margin: '1px 0px'
    },
    titleNumber: {
        color: "rgb(209,213,219)",
    }
    // "min-w-[14px] min-h-[14px] rounded-full border border-gray-400 mx-1"
    // min-w-[13px] min-h-[13px] border-2 border-white rounded-full mx-1
    // border border-gray-200 rounded-lg flex w-full p-3 mb-3 items-center cursor-pointer transition-all
}))



export default function Index({ setAnswerQuestion, indexQuestion, ind, data, Click, setClick, question }) {

    const classes = useStyles();

    const handleClickAnswer = (ind, data) => {
        setClick(ind)
        setAnswerQuestion(data, indexQuestion)
    }

    useEffect(() => {
        if (question.answer) {
            setClick(question.answer-1)
        } else {
            setClick(null)
        }
    }, [question])

    return (
        <div
            className={`${Click === ind ? "bg-primaryColor" : ''} ${classes['root']} `} onClick={() => handleClickAnswer(ind, data)}>
            <div className={`${Click === ind ? classes['gridQuestionTrue'] : classes['gridQuestionFalse']} `}></div>
            <div className={`mx-1 ${classes['titleNumber']} `} >{ind+1}</div>
            <div className={`${Click === ind ? "text-white" : "text-black"} mx-1`}>{data.question}</div>
        </div>
    )
}
